import React, { useState, useEffect } from "react";
import { Card, CardBody } from "reactstrap";
import { ReactComponent as DeleteIcon } from "../../assets/utils/images/svgs/Delete.svg";
import { ReactComponent as UploadIcon } from "../../assets/utils/images/svgs/Upload.svg";
import { toast } from "react-toastify";
import { useDeleteProfileImage, useUpdateProfilePhoto } from "Api/Profile";


const Photo = ({ userDetails, disable, data }) => {
    const existingProfilePic = data?.profileImage;
    const [userImg, setUserImg] = useState("");
    const { trigger: updateProfilePhoto } =
        useUpdateProfilePhoto();

    const {
        trigger: deleteProfileImage,
        isMutating: isDeletingImage,
    } = useDeleteProfileImage();

    useEffect(() => {
        if (existingProfilePic) {
            setUserImg(`${existingProfilePic}`);
        }
    }, [existingProfilePic]);

    const handleImageUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            // Check file size (2MB)
            const maxSizeInBytes = 2 * 1024 * 1024; // 2 MB
            const validTypes = ["image/png", "image/jpeg", "image/bmp"];

            if (file.size > maxSizeInBytes) {
                toast.error("Bestandsgrootte mag niet groter zijn dan 2MB.");
                return;
            }

            if (!validTypes.includes(file.type)) {
                toast.error("Ongeldig bestandsformaat. Alleen PNG, JPG, en BMP zijn toegestaan.");
                return;
            }

            const reader = new FileReader();
            reader.onloadend = () => {
                setUserImg(reader.result);
                updateUserProfile(file);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleDeleteImage = async () => {
        try {
            await deleteProfileImage();
            setUserImg("");
        } catch (error) {
            console.error("Failed to delete profile image:", error);
        }
    };

    const updateUserProfile = (value) => {
        const formData = new FormData();
        formData.append("file", value);
        formData.append("iAdminId", data?.iAdminId);

        updateProfilePhoto({
            data: formData,
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
            .then((response) => {
                if (response.data.status) return;
                if (!response.data.success) {
                    const errors = response.data.data.file;
                    if (Array.isArray(errors)) {
                        toast.error(errors.join(","));
                    } else {
                        toast.error(errors);
                    }
                }
            })
            .catch((error) => {
                console.error("API error:", error);
            });
    };
    return (

        <Card className="main-card h-110 gebruikers-view" style={{ height: "100%" }}>
            <CardBody className="d-flex flex-column algemeen">
                <h5 className="mb-4">{userImg ? "Foto" : "Foto toevoegen"}</h5>
                <div className="user-img text-center mx-auto my-auto">
                    {userImg ? (
                        <div className="img-box">
                            <img src={userImg} alt="img" />
                            <button
                               onClick={handleDeleteImage}
                            >
                                <DeleteIcon />
                            </button>
                        </div>
                    ) : (
                        <div className="img-input">
                            <input type="file" accept="image/*" onChange={handleImageUpload} disabled={disable}
                                style={disable ? { pointerEvents: 'none' } : {}} />
                            <div className="mb-2">
                                <UploadIcon />
                            </div>
                            <p>Sleep of klik op het icoon om foto toe te voegen</p>
                            <p>Toegestane bestandsformaten: *.jpg, *.png, *.bmp</p>
                        </div>
                    )}
                </div>
            </CardBody>
        </Card>
    )
}
export default Photo;